import { ScrollReveal } from "../ui/ScrollReveal";
import { IMAGES } from "../../data/content";

const SCENARIOS = [
  { title: "Working With A Trainer?", desc: "Use MindBodyLife.pro for extra guidance, lifestyle learning, mindset development, breathing exercises & daily reinforcement.", img: IMAGES.gym3 },
  { title: "Already At The Gym?", desc: "Use MindBodyLife.pro to stay consistent, discover new workouts, improve knowledge & build better habits.", img: IMAGES.gym1 },
  { title: "Working Out At Home?", desc: "We've got you covered — no matter where you start, there is a place for you here.", img: IMAGES.dumbbell1 },
];

export const GymCompat = () => {
  return (
    <section className="relative bg-[#020617] py-24 sm:py-32 px-5 sm:px-8" data-testid="gym-compat-section">
      <div className="max-w-7xl mx-auto">
        <ScrollReveal>
          <span className="font-mono-brand text-xs uppercase tracking-[0.25em] text-cyan-400">Fits Your Journey</span>
          <h2 className="font-display font-extrabold uppercase text-2xl sm:text-3xl lg:text-4xl text-white mt-4 max-w-3xl leading-tight">
            Your Trainer Loves This. Your Gym Loves This. Your Home Loves This.
          </h2>
          <p className="text-slate-400 mt-4 max-w-2xl text-sm sm:text-base">
            MindBodyLife.pro doesn't replace your fitness journey — it makes it better.
          </p>
        </ScrollReveal>

        <div className="grid sm:grid-cols-3 gap-5 mt-14">
          {SCENARIOS.map((s, i) => (
            <ScrollReveal key={s.title} delay={i * 0.1} className="group relative rounded-2xl overflow-hidden aspect-[4/5]" data-testid={`gym-compat-card-${i}`}>
              <img src={s.img} alt={s.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#020617] via-[#020617]/60 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="font-display font-bold text-lg text-white leading-tight">{s.title}</h3>
                <p className="text-xs sm:text-sm text-slate-300 mt-2 leading-relaxed">{s.desc}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};
